var Model = function Model(value, animate) {
    if ( value === void 0 ) value = 0;

    this.handle = {
        transform: 'translateX(' + value + 'px)',
        transition: animate
    };
};

export default Model;

//# sourceMappingURL=SwitchModel.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-inputs-common/dist/es/SwitchModel.js
// module id = ../../../../@telerik/kendo-inputs-common/dist/es/SwitchModel.js
// module chunks = 3